// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab-module--tab--HA6JK"};